;(typeof module.exports === "function" ? module.exports.options : module.exports).template = require("-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./example.vue")
if (module.hot) {
(function () {
var hotAPI = require("E:\\zhe_li_you_xuan\\hotelInfo\\node_modules\\vue-hot-reload-api\\index.js")
hotAPI.install(require("vue"))
if (!hotAPI.compatible) return
var id = "-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./example.vue"
hotAPI.createRecord(id, module.exports)
module.hot.accept(["-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./example.vue"], function () {
var newOptions = null
var newTemplate = require("-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./example.vue")
hotAPI.update(id, newOptions, newTemplate)
})
})()
}


//////////////////
// WEBPACK FOOTER
// ./src/views/example.vue
// module id = 62
// module chunks = 0